import { ModuleWithProviders, NgModule } from '@angular/core';
import { QuickAdditDirective } from './directives/quick-addit.directive';
import { QuickAdditModal } from './modals/quick-addit.modal';
import { FormsModule } from '../forms/forms.module';
import { ChassisModalModule } from '../modals/modals.module';
import { QuickAdditService } from './services/quick-addit.service';


@NgModule({
    imports: [FormsModule, ChassisModalModule],
    exports: [QuickAdditDirective],
    declarations: [QuickAdditDirective, QuickAdditModal],
    entryComponents: [QuickAdditModal],
    providers: [],
})
export class QuickAdditModule {

    public static forRoot(): ModuleWithProviders {

        return {
            ngModule: QuickAdditModule,
            providers: [QuickAdditService]
        };

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/quick-addit/quick-addit.module.ts